export default __webpack_public_path__ + "static/media/category.2b537e33.svg";